module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "savethedate"
  }, [_c('img', {
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/savethedate.png'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-395ebe7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Savethedate.vue
// module id = 359
// module chunks = 0